<template>
    <div class="dispositivos-reportes">
        <h2>Reportes - Dispositivos Médicos</h2>
        <div class="reportes-content">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-card>
                        <div slot="header">
                            <span>Reporte de Inventario</span>
                        </div>
                        <div class="reporte-item">
                            <h4>Total de Dispositivos: {{ reporteInventario.total }}</h4>
                            <p>Disponibles: {{ reporteInventario.disponibles }}</p>
                            <p>En Uso: {{ reporteInventario.enUso }}</p>
                            <p>En Mantenimiento: {{ reporteInventario.mantenimiento }}</p>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card>
                        <div slot="header">
                            <span>Reporte de Mantenimiento</span>
                        </div>
                        <div class="reporte-item">
                            <h4>Mantenimientos Programados: {{ reporteMantenimiento.programados }}</h4>
                            <p>En Proceso: {{ reporteMantenimiento.enProceso }}</p>
                            <p>Completados: {{ reporteMantenimiento.completados }}</p>
                            <p>Pendientes: {{ reporteMantenimiento.pendientes }}</p>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top: 20px;">
                <el-col :span="24">
                    <el-card>
                        <div slot="header">
                            <span>Gráfico de Actividad</span>
                        </div>
                        <div class="grafico-container">
                            <div class="grafico-placeholder">
                                <i class="el-icon-s-data-analysis" style="font-size: 48px; color: #607D8B;"></i>
                                <p>Gráfico de actividad de dispositivos médicos</p>
                                <p>Aquí se mostrarían las estadísticas en tiempo real</p>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosReportes',
    data() {
        return {
            reporteInventario: {
                total: 53,
                disponibles: 35,
                enUso: 12,
                mantenimiento: 6
            },
            reporteMantenimiento: {
                programados: 8,
                enProceso: 3,
                completados: 15,
                pendientes: 2
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dispositivos-reportes {
    padding: 20px;

    h2 {
        color: var(--color-primary);
        margin-bottom: 30px;
        font-weight: 600;
    }

    .reportes-content {
        .el-card {
            margin-bottom: 20px;
            border-radius: var(--radius-md);
            border: 1px solid var(--color-border);

            :deep(.el-card__header) {
                background-color: var(--color-surface-base);
                border-bottom: 1px solid var(--color-border);
                border-radius: var(--radius-md) var(--radius-md) 0 0;

                span {
                    color: var(--color-primary);
                    font-weight: 500;
                }
            }

            .reporte-item {
                padding: 20px;

                h4 {
                    color: var(--color-primary);
                    margin-bottom: 15px;
                    font-weight: 600;
                }

                p {
                    color: var(--color-surface-muted);
                    margin: 8px 0;
                    font-size: 14px;
                }
            }

            .grafico-container {
                padding: 40px;
                text-align: center;

                .grafico-placeholder {
                    color: var(--color-surface-muted);

                    p {
                        margin: 10px 0;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>